import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_LCS = () => (
  <DAAModuleSubtopic
    title="Dynamic Programming – Longest Common Subsequence (LCS)"
    videos={[
      "https://www.youtube.com/embed/jHGgXV27qtk",
      "https://www.youtube.com/embed/sSno9rV8Rhg"
    ]}
    takeaways={[
      { text: "A subsequence is a sequence that appears in the same order but not necessarily contiguously." },
      { text: "Time Complexity: O(m × n), where m and n are lengths of the two strings." },
      { text: "Space Complexity: O(m × n), but can be optimized to O(min(m, n)) using a rolling array." },
      { text: "LCS has optimal substructure and overlapping subproblems, making it suitable for dynamic programming." },
      { text: "Recursive solutions are inefficient due to repeated recomputation; DP avoids this." }
    ]}
    questions={[
      {
        text: "Given 2 sequences: X = ABCBADB and Y = BDCBAA. Find the longest common subsequence using dynamic programming. Show all steps in the c table and b table."
      },
      {
        text: "Find the longest common subsequence for the strings 'ACCGGTCGAGT' and 'GTCGTTCGG' using a dynamic programming table."
      },
      {
        text: "Write pseudocode for the dynamic programming approach to solve the LCS problem and apply it on two strings of your choice."
      },
      {
        text: "Given two DNA sequences DNA1 and DNA2, find the minimum number of single-character edits (insertions, deletions, or substitutions) required to transform DNA1 into DNA2. Example: DNA1 = 'AGTACG', DNA2 = 'GTCAGT'."
      }
    ]}
    exampleVideos={[
      "https://www.youtube.com/embed/-UoE0M2FSdU",
      "https://www.youtube.com/embed/5emt2p3hSNI"
    ]}
  />
);

export default DAA_LCS ;
